import { Button, Divider, LoadingOverlay } from '@mantine/core';
import { modals } from '@mantine/modals';
import { useState } from 'react';

import { SortDirection } from '@e-origin/shared';

import { InviteOnline, SearchBox, Table } from '@components';
import { ContentLayout } from '@features/layout';
import { useForwarders, useForwardersMeta } from '@hooks/forwarder';
import { useForwarderListColumns } from './useForwarderListColumns';

export const ForwarderList = () => {
  const columns = useForwarderListColumns();

  const [criteria, setCriteria] = useState({
    filters: {
      searchQuery: '',
    },
    pagination: {
      page: 1,
      size: 10,
    },
    sorting: {
      field: 'createdAt',
      direction: SortDirection.DESC,
    },
  });

  const { data: forwardersList, isLoading } = useForwarders(criteria);
  const { data: forwardersMeta } = useForwardersMeta(criteria.filters);

  const handleSearch = (searchQuery: string) => {
    setCriteria({
      ...criteria,
      filters: {
        ...criteria.filters,
        searchQuery,
      },
    });
  };

  const handlePagination = (page: number, size: number) => {
    setCriteria({
      ...criteria,
      pagination: {
        page,
        size,
      },
    });
  };

  const openInviteOnline = () => {
    modals.open({
      title: 'Invite online forwarder',
      children: <InviteOnline onHide={modals.closeAll} />,
    });
  };

  if (!forwardersList) {
    return <LoadingOverlay visible={isLoading} overlayProps={{ radius: 'sm', blur: 2 }} />;
  }

  return (
    <ContentLayout>
      <ContentLayout.Header>
        <ContentLayout.Title>Forwarders</ContentLayout.Title>
        <ContentLayout.Filters>
          <Button data-pw="signUp-submit-btn" type="submit" variant="filled" size="lg" onClick={openInviteOnline}>
            Invite online forwarder
          </Button>
          <SearchBox handleSearch={handleSearch} placeholder="Search " />
        </ContentLayout.Filters>
      </ContentLayout.Header>
      <ContentLayout.Content>
        <Table columns={columns} dataSource={forwardersList ?? []} total={forwardersMeta.total} onPaginationChange={handlePagination} isLoading={isLoading} />
      </ContentLayout.Content>
      <Divider my="lg" />
    </ContentLayout>
  );
};
